import React from 'react';
import { Row } from '@grubhubprod/gh-cookbook-react';
import { TieredAccountHeaderText } from 'src/components/enterprise/Parents/Admin/TieredAccountTable/TieredAccountTableHeaderRow/TieredAccountHeaderText/TieredAccountHeaderText';

export interface TieredAccountTableHeaderRowProps {
  headers: string[];
}

// Using Row directly instead of TieredAccountRow because Table header implementation has border styles by default
export const TieredAccountTableHeaderRow: React.FC<TieredAccountTableHeaderRowProps> =
  ({ headers }) => {
    return (
      <Row>
        {headers.map((header) => (
          <TieredAccountHeaderText key={header} width={6} headerText={header} />
        ))}
      </Row>
    );
  };
